import { inject, Injectable } from '@angular/core';
import { WebchatInstance } from '@conversational/chat-models';

import { ConversationalChatPersistenceService } from './conversational-chat-persistence.service';
import { CognigyClientAnalyticsService } from './cognigy-client/cognigy-client-analytics.service';

/**
 * Service to register webchat events
 *
 * For a list of event types see: https://github.com/Cognigy/Webchat/blob/main/docs/analytics-api.md#webchat-events
 *
 */
@Injectable({
  providedIn: 'root',
})
export class ConversationalChatEventsService {
  readonly #conversationalChatPersistenceService = inject(
    ConversationalChatPersistenceService
  );
  readonly #cognigyClientAnalyticsService = inject(
    CognigyClientAnalyticsService
  );

  registerWebchatSwitchSessionListener() {
    this.#cognigyClientAnalyticsService.addListener((event) => {
      if (event.type === 'webchat/switch-session') {
        this.#conversationalChatPersistenceService.setSessionId(event.payload);
      }
    });
  }

  registerWebchatIncomingMessageListener(
    webchat: WebchatInstance,
    referrerHref: string,
    chatbotAnalytics: string[],
    loginEncryptedToken: string | null
  ) {
    this.#cognigyClientAnalyticsService.addListener((event) => {
      if (
        event.type === 'webchat/incoming-message' &&
        (event.payload.data.initialData === true ||
          event.payload.data.handoverData === true)
      ) {
        webchat.sendMessage('', {
          currentUserUrl: referrerHref,
          chatbotAnalytics,
          loginEncryptedToken,
        });
      }
    });
  }
}
